import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  image: 'data-asset-img',
  video: 'data-asset-video',
}
const qsAll = {
  sections: 'data-section-type="style-assets"',
  media: 'data-style-media',
}

const initSection = (section) => {
  const image = section.querySelector(`[${qs.image}]`)
  const video = section.querySelector(`[${qs.video}]`)
  const media = section.querySelectorAll(`[${qsAll.media}]`)
  media.forEach(medium => {
    medium.addEventListener('click', () => {
      const imageUrl = medium.dataset.styleMedia
      const videoUrl = medium.dataset.styleVideo
      image.src = `${imageUrl}?width=800`
      if(videoUrl) {
        video.innerHTML = `<iframe id="viewingBlockVideoiFrame" src="${videoUrl}?autoplay=1&loop=1&autopause=0" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" title="Related Media Content" webkitallowfullscreen mozallowfullscreen allowfullscreen data-ready="true" class="w-full h-full bg-white"></iframe>`
      } else {
        video.innerHTML = ''
      }
    })
  })
}

export const setupStyleAssets = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    initSection(section)
  })
}